import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch } from "react-redux";
import { useState } from "react";
import {
  openConfirmToggle,
  openFormModal,
  openViewModal,
} from "../../store/reducers/users/users.reducer";
import { getUserByIdThunk } from "../../store/reducers/users/users.thunks";
import Modal from "../UI/Modal";

const UserActions = ({ userId, isActive }) => {
  const dispatch = useDispatch();
  const [editModalOpen, setEditModalOpen] = useState(false);

  const handleEdit = async () => {
     await dispatch(getUserByIdThunk(userId));
    dispatch(openFormModal());
  };
  const handleToggle = () => {
    dispatch(
      openConfirmToggle({
        id: userId,
        isActive: !isActive, // siguiente estado
      }),
    );
  };
  const handleView = () => {
    dispatch(openViewModal());
    dispatch(getUserByIdThunk(userId));
  };

  const itemClass =
    "dropdown-item px-16 py-8 rounded d-flex align-items-center gap-2 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900";

  return (
    <div className="dropdown text-center">
      <button
        type="button"
        className="btn btn-sm"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Icon
          icon="ph:dots-three-outline-vertical-fill"
          width="20"
          className="text-neutral-700"
        />
      </button>

      <ul className="dropdown-menu p-12 border bg-base shadow">
        <li>
          <button className={itemClass} onClick={handleView}>
            <Icon icon="mdi:eye-outline" width="18" />
            <span>Ver</span>
          </button>
        </li>

        <li>
          <button className={itemClass} onClick={handleEdit}>
            <Icon icon="mdi:pencil-outline" width="18" />
            <span>Editar</span>
          </button>
        </li>

        <li>
          <button
            className={`${itemClass} ${isActive ? "text-danger" : "text-success"}`}
            onClick={handleToggle}
          >
            <Icon
              icon={
                isActive
                  ? "mdi:account-off-outline"
                  : "mdi:account-check-outline"
              }
              width="18"
            />
            <span>{isActive ? "Desactivar" : "Activar"}</span>
          </button>
        </li>
      </ul>

      {/* Modal temporal para editar hasta que se implemente el formulario completo */}
      <Modal
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        title="Editar usuario"
        size="sm"
      >
        <div className="text-center py-4">
          <Icon
            icon="mdi:tools"
            width="48"
            className="text-warning mb-3"
          />
          <p className="mb-3">
            La funcionalidad de edición de usuarios está en desarrollo.
          </p>
          <p className="text-sm text-secondary-light mb-3">
            Por ahora puedes ver los detalles del usuario y desactivarlo si es necesario.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => setEditModalOpen(false)}
          >
            Entendido
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default UserActions;
